import isNil from 'lodash/isNil';

const formatFileSize = (bytes, decimalPoint) => {
  if (bytes === 0 || isNil(bytes)) return '0 Bytes';

  const k = 1024;
  const dp = decimalPoint || 2;
  const sizes = ['Bytes', 'KB', 'MB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / (k ** i)).toFixed(dp))} ${sizes[i]}`;
};
export default formatFileSize;



// WEBPACK FOOTER //
// ./src/common/methods/formatFileSize.js